import React from "react"
import { PivotSuggestion } from "../../typings"

interface Props {
  pivotSuggestions: PivotSuggestion[]
}

const PivotSuggestions = ({ pivotSuggestions }: Props) => (
  <div className="bg-white border rounded shadow">
    <div className="border-b p-3">
      <h5 className="font-bold uppercase text-gray-600">
        Pivot Suggestions to Reach 1M+ Owners
      </h5>
    </div>
    <div className="p-5 overflow-x-scroll">
      {pivotSuggestions.length > 0 && (
        <table className="w-full p-5 text-gray-700 whitespace-no-wrap">
          <thead>
            <tr>
              <th className="text-left text-blue-900">Tag 1</th>
              <th className="text-left text-blue-900">Tag 2</th>
              <th className="text-left text-blue-900">Tag 3</th>
            </tr>
          </thead>

          <tbody>
            {pivotSuggestions.map(({ tags }, index) => (
              <tr key={index}>
                <td>{tags[0]}</td>
                <td>{tags[1]}</td>
                <td>{tags[2]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {pivotSuggestions.length == 0 && (
        <p>No suggestions. This combination is pretty terrible.</p>
      )}
    </div>
  </div>
)

export default PivotSuggestions
